export const MACRO_DEFS = [
  { key: 'calories', label: 'kcal', color: '#f43f5e' },
  { key: 'protein', label: 'g', color: '#60a5fa' },
  { key: 'carbs', label: 'g', color: '#fbbf24' },
  { key: 'fat', label: 'g', color: '#c084fc' }
];

export const MACRO_NAMES = { calories: 'Calories', protein: 'Protein', carbs: 'Carbs', fat: 'Fat' };

export const hasMacros = (item) =>
  item.calories != null || item.protein != null || item.carbs != null || item.fat != null;

export const scaleMacro = (val, grams) => (val != null ? +((val / 100) * grams).toFixed(1) : null);
